import script from "./DynamicImage.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicImage.vue?vue&type=script&setup=true&lang=js"

import "./DynamicImage.vue?vue&type=style&index=0&id=6142e6bf&scoped=true&lang=css"

import exportComponent from "D:\\WorkJob\\SmartCarRace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6142e6bf"]])

export default __exports__